import { CustomTableHeader } from '../../../../components/CustomTable';
import { getTheme } from '../../../../utils/getTheme';
import {
  renderComponenteAF,
  renderTipoProduto,
} from '../ProcessosLicitatorios/auxiliarProcessosLicitatorios';

export const valoresExibidosOffCanvasArps: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorChaves: '',
  separadorIdentificacao: '',
  separadorItens: '',
  separadorObservacoes: '',

  //Específicos
  statusArp: 'Status ARP',
  componenteAf: 'Componente AF',
  itemAdquirido: 'Item Adquirido',
  fornecedorNomeFantasia: 'Fornecedor',
  leiLicitacao: 'Lei de Licitação',
  numeroSeiArp: 'Processo Aquisitivo',
  numeroArp: 'Nº ARP',
  dataPublicacao: 'Início da Vigência',
  dataVigencia: 'Final da Vigência',
  prazoVigencia: 'Prazo',
  itensAdquiridos: 'Itens Adquiridos',
  valorTotal: 'Valor Total R$',
  nItens: 'Nº Itens',
};

export const headersArps = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 12, key: 'statusArp' },
  { text: 'Comp. AF', width: 15, key: 'componenteAf' },
  { text: 'Nº ARP', width: 8, key: 'numeroArp' },
  { text: 'Fornecedor', width: 20, key: 'fornecedor' },
  { text: 'Denominação/Kit', width: 20, key: 'itemAdquirido' },
  { text: 'Nº Itens', width: 2, key: 'nItens' },
  { text: 'Valor Total R$', width: 10, key: 'valorTotal' },
];

export const headersItensArp = [
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Tipo Cota', width: 10, key: 'itemTipoCota' },
  { text: 'Produto', width: 50, key: 'itemProduto' },
  { text: 'Qtd Registrada', width: 10, key: 'itemQtdRegistrada' },
  { text: 'Homologado R$', width: 10, key: 'itemValorHomologado' },
  { text: 'Reequilibrio R$', width: 10, key: 'itemValorReequilibrio' },
  { text: 'Valor Total R$', width: 10, key: 'itemValorTotal' },
];

export const valoresExibidosItensARP: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorVinculos: '',
  separadorDadosArp: '',
  separadorItemArp: '',
  separadorQuantidades: '',
  separadorContratos: '',
  separadorObservacoes: '',

  //Dados da ARP
  arpId: 'Nº da ARP',
  fornecedor: 'Fornecedor',
  produtoDafId: 'Produto DAF (Item)',

  //Dados do Item da ARP
  tipoCota: 'Tipo de Cota',
  empateFicto: 'Empate Ficto',
  embalagemFator: 'Fator Embalagem',

  //Quantidades
  qtdAdministrativa: 'Qtd Administrativa',
  qtdEstrategico: 'Qtd Estratégico',
  qtdJudicial: 'Qtd Judicial',
  qtdOutro: 'Qtd Outro',
  qtdTotal: 'Qtd Registrada',

  //Valor
  valorUnitHomologado: 'Valor Homologado R$',
  valorUnitReequilibrio: 'Valor Reequilíbrio R$',
  valorTotal: 'Valor Total R$',

  //Métricas
  medContratos: 'Contratos',
  medQtdContratada: 'Qtd Contratada',
  medValorContratado: 'Valor Contratado',
  medQtdSaldo: 'Qtd Saldo',
  medValorSaldo: 'Valor Saldo',
  medPercentSaldo: '% Saldo',
};

export const fieldObjectArps = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];

export type ArpsTableRow = {
  id: string | number;
  status: string;
  componenteAf: string;
  numeroArp: string;
  fornecedor: string;
  denominacaoKit: string;
  denominacaoKitBool: string;
  [key: string]: any;
};

export const renderStatusVigencia = (value: string) => {
  const theme = getTheme();

  const statusStyleMap: Record<string, { bg: string; text: string }> = {
    'Não Publicado': {
      bg: '#ffde26',
      text: '#000',
    },
    Vigente: {
      bg: theme.colors.azulgov,
      text: '#fff',
    },
    'Não Vigente': {
      bg: '#919191',
      text: '#fff',
    },
  };

  const { bg, text } = statusStyleMap[value] ?? {
    bg: '#b6b6b6',
    text: '#000',
  };

  return (
    <div
      style={{
        backgroundColor: bg,
        color: text,
        padding: '10px',
        borderRadius: '4px',
        textAlign: 'center',
        fontWeight: 500,
      }}
    >
      {value}
    </div>
  );
};

export const headersArpsCustomTable: CustomTableHeader<ArpsTableRow>[] = [
  { text: '', width: 1, key: '', renderable: false },
  { text: 'ID', width: 6, key: 'id', fieldType: 'number', textAlign: 'center' },
  {
    text: 'Status',
    width: 10,
    key: 'status',
    fieldType: 'select',
    renderCell: (value) => renderStatusVigencia(value),
  },
  {
    text: 'Componente AF',
    width: 12,
    key: 'componenteAf',
    fieldType: 'select',
    renderCell: (value) => renderComponenteAF(value),
  },
  {
    text: 'Nº ARP',
    width: 10,
    key: 'numeroArp',
    fieldType: 'text',
  },
  {
    text: 'Fornecedor',
    width: 30,
    key: 'fornecedor',
    fieldType: 'text',
  },
  {
    text: 'Tipo',
    width: 5,
    key: 'denominacaoKitBool',
    fieldType: 'select',
    renderCell: (value) => renderTipoProduto(value),
  },
  {
    text: 'Denominação ou Kit',
    width: 50,
    key: 'denominacaoKit',
    fieldType: 'text',
  },
];
